import RoomAllotmentCalendarView from './RoomAllotmentCalendarView';

export default RoomAllotmentCalendarView;
